import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'About', href: '#about' },
    { name: 'Curriculum', href: '#curriculum' },
    { name: 'Testimonials', href: '#testimonials' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-ivory/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
        {/* Logo */}
        <a href="#" className="flex items-center gap-3 group">
            <div className="w-11 h-11 bg-gradient-to-br from-white to-sand/30 rounded-[14px] flex items-center justify-center shadow-md shadow-royal-maroon/5 border border-royal-maroon/10 group-hover:scale-105 transition-transform duration-300 overflow-hidden">
                <img 
                  src="logo.png" 
                  alt="Swaram Academy Logo" 
                  className="h-7 w-7 object-contain drop-shadow-sm" 
                />
            </div>
            <span className="font-display text-2xl tracking-widest text-royal-maroon font-semibold uppercase">
                Swaram Academy
            </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="text-gray-600 hover:text-royal-maroon text-sm font-medium tracking-wide transition-colors uppercase"
            >
              {link.name}
            </a>
          ))}
          <a
            href="#contact"
            className="px-6 py-2.5 bg-royal-maroon text-white text-sm tracking-wide rounded hover:bg-royal-maroon-light transition-colors duration-300 shadow-lg shadow-royal-maroon/20"
          >
            Enroll Now
          </a>
        </div>

        {/* Mobile Toggle */}
        <button
          className="md:hidden text-royal-maroon p-2"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Nav Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-ivory border-t border-gray-100 shadow-xl py-6 px-6 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="text-gray-600 hover:text-royal-maroon text-lg font-medium"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {link.name}
            </a>
          ))}
          <a
            href="#contact"
            className="mt-2 text-center w-full px-6 py-3 bg-royal-maroon text-white text-base rounded shadow-lg"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Enroll Now
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;